export function decimal(value, locale, minimumFractionDigits = 0, maximumFractionDigits = 3) {
	if(value) {
		return value.toLocaleString(locale || this.userLocale, {
			style: 'decimal',
			useGrouping: true,
			minimumFractionDigits: minimumFractionDigits,
			maximumFractionDigits: maximumFractionDigits
		});
	}

	return "0";
}

function decimalWithUnit(value, unit, locale = 'de-DE', minimumFractionDigits = 0, maximumFractionDigits = 3) {
	return `${decimal(value, locale, minimumFractionDigits, maximumFractionDigits)} ${unit}`;
}

export function area(value, unit = 'm²', locale = 'de-DE') {
	return decimalWithUnit(value, unit, locale);
}

/**
 * Call filter in template as {{ variableToFormat | currency(currencyISO) }}
 */
export default {
	computed: {
		userLocale() {
			return this.$store.state.user.userLocale;
		}
	},
	methods: {
		unitLabel(unit) {
			return this.$t(`unit.${unit}`);
		}
	},
	filters: {
		currency: (value, currency = 'EUR', locale = 'de-DE') => {
			return value.toLocaleString(locale, {
				style: 'currency',
				currency: currency,
				currencyDisplay: "symbol",
				useGrouping: true
			});
		},
		number: decimal,
		numberWithUnit: decimalWithUnit,
		area: area
	}
}